(function () {
  if (window.KimiQuickShopClickLoadInitialized) return;
  window.KimiQuickShopClickLoadInitialized = true;

  var LOADING_ATTR = 'data-kimi-quick-loading';

  function clearLoading(btn, observer, timer) {
    if (observer) observer.disconnect();
    if (timer) window.clearTimeout(timer);
    btn.removeAttribute(LOADING_ATTR);
    btn.removeAttribute('aria-busy');
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.quick-product__btn');
    if (!btn || !btn.classList.contains('quick-product__btn--not-ready')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (btn.hasAttribute(LOADING_ATTR)) return;

    var card = btn.closest('.grid-product');
    if (!card) return;

    var handle = card.getAttribute('data-product-handle');
    var productId = card.getAttribute('data-product-id');

    if (!handle || !productId || !window.theme || typeof window.theme.preloadProductModal !== 'function') {
      return;
    }

    btn.setAttribute(LOADING_ATTR, 'true');
    btn.setAttribute('aria-busy', 'true');

    var timer;
    var observer = new MutationObserver(function () {
      if (!btn.classList.contains('quick-product__btn--not-ready')) {
        clearLoading(btn, observer, timer);

        window.requestAnimationFrame(function () {
          btn.click();
        });
      }
    });

    observer.observe(btn, {
      attributes: true,
      attributeFilter: ['class']
    });

    timer = window.setTimeout(function () {
      clearLoading(btn, observer, timer);
    }, 10000);

    try {
      window.theme.preloadProductModal(handle, productId, btn);
    } catch (error) {
      clearLoading(btn, observer, timer);
    }
  }, true);
})();
